import { IImageConfigValue } from '@bg-shared';

export const getSourceMediaQuery = (sizes: IImageConfigValue['sizes'], index: number): string => {
    if (sizes[index] === undefined) {
        return '';
    }

    if (sizes.length > 1 && index + 1 < sizes.length) {
        return `(max-width: ${sizes[index] - 1}px)`;
    }

    if (sizes.length > 1) {
        return `(min-width: ${sizes[index - 1]}px)`;
    }

    return '';
};
